import type Phaser from 'phaser';
import type {ActorRoleCue} from './actorRoleCue';
/** Small ground marks remain below the original body art and never receive input. */
export function drawActorRoleCue(graphics:Phaser.GameObjects.Graphics,cue:ActorRoleCue,scale=1):void {
 graphics.clear().setVisible(cue.shape!=='none');
 if(cue.shape==='none')return;
 graphics.lineStyle(Math.max(1.25,1.7*scale),cue.color,.9);
 if(cue.shape==='selected'||cue.shape==='npc'){
  const w=(cue.shape==='selected'?25:19)*scale,h=(cue.shape==='selected'?10:8)*scale;
  graphics.beginPath().moveTo(0,-h).lineTo(w,0).lineTo(0,h).lineTo(-w,0).closePath().strokePath();
 }else if(cue.shape==='enemy'){
  for(const side of [-1,1])graphics.beginPath().moveTo(side*24*scale,-5*scale).lineTo(side*15*scale,0).lineTo(side*24*scale,5*scale).strokePath();
 }else{
  graphics.strokeEllipse(0,0,43*scale,16*scale);
  if(cue.shape==='party')graphics.fillStyle(cue.color,.95).fillCircle(-24*scale,0,2*scale).fillCircle(24*scale,0,2*scale);
 }
}
